import BaseObject from '../../../../base/base_object';
import {FIREBASE} from './firebase_hybrid_consts';
import _ from "../../../../utils/underscore";
import Device from "../../../../utils/device/device";
import {KEY_NAME} from "../../native/native_const";




/**
 *
 *
 */
class FireBase extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FireBase';
    _HybridService = null;
    _InstanceId = '';
    _AppId = '';
    _bEnable = false;

    init(params) {

        super.init();

        if(_.isNullOrUndefined(params)){
            return;
        }
        if (Device.hybrid.isHybrid) {
            if (Device.os.isIOS) {
                params = params.ios;
            } else if (Device.os.isAndroid) {
                params = params.android;
            }
        }

        if(!_.isNullOrUndefined(params) && params.enable){
            this._bEnable = true;
        }
    }

    initFeatures(hybridSrv) {

        this._HybridService = hybridSrv;

        if(this._bEnable) {
            this._getData();
        }
        return this;
    }

    _getData(){

        this._HybridService.getFireBaseData().then(data => {

            let json = _.safeJSONandDecode(data);
            let error = json[KEY_NAME.ERROR];
            if (error !== 0) {
                return;
            }

            const fbdata = json[KEY_NAME.DATA];

            this._InstanceId = fbdata[FIREBASE.INSTANCE_ID];
            this._AppId = fbdata[FIREBASE.APP_ID];
        });
    }

    getAppMareketingData(){

        const data = {FirebaseAppID: this._AppId, FirebaseAppInstanceID: this._InstanceId};

        return data;
    }

}

export default FireBase;
